import Vue from 'vue';

const state = {
    data: [],
};

const getters = {
    getUsers(state) {
        return state.data;
    },
    isActive(state) {
        if (state.data.length === 0) {
            return 'Indefinido';
        }
        if (state.data[0].active !== undefined) {
            return (state.data[0].active == 1) ? 'Activo' : 'Inactivo';
        }

        return 'Sin definir';
    },
    getSelectableUsers(state) {
        const listItem = [];
        state.data.forEach((item) => {
            if (item.active === '1') {
                listItem.push({value: item.id, label: item.name});
            }
        });

        return listItem;
    }
};

const mutations = {
    SET_DATA(state, users) {
        state.data = users;
    },
};

const actions = {

    loadUsers({dispatch, commit}) {

        const params = {
            context: 'edit'
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/users", {params})
                .then(({data}) => {

                    const userRows = [];

                    data.forEach((user) => {
                        userRows.push({
                            id: user.id,
                            username: user.username,
                            email: user.email,
                            first_name: user.first_name,
                            last_name: user.last_name,
                            name: `${user.first_name} ${user.last_name}`,
                            rut: user.rut,
                            rol: user.roles[0],
                            active: (user.acf.active === true) ? '1' : '0'
                        })
                    });

                    commit('SET_DATA', userRows);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    loadSingleUser({dispatch, commit}, userId) {

        const params = {
            context: 'edit'
        };

        const token = this.state.login.user.token;
        const currentUserID = this.state.login.user.ID;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().get("/wp/v2/users/" + (userId || currentUserID) + '?XDEBUG_SESSION_START=PHP_STORM', {params})
                .then(({data: user}) => {

                    const userRow = [{
                        id: user.id,
                        username: user.username,
                        email: user.email,
                        first_name: user.first_name,
                        last_name: user.last_name,
                        name: `${user.first_name} ${user.last_name}`,
                        rut: user.rut,
                        rol: user.roles[0],
                        house_id: user.house_id,
                        active: (user.acf.active === true) ? '1' : '0'
                    }];

                    commit('SET_DATA', userRow);
                    resolve();

                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    updateSingleUser({dispatch, commit, state}) {

        const userData = state.data[0];
        const userId = userData.id;
        const params = {
            first_name: userData.first_name,
            last_name: userData.last_name,
            email: userData.email,
            rut: userData.rut,
            active: userData.active || '0'
        };


        if (undefined !== userData.password) {
            if (userData.password_confirm === userData.password) {
                console.log("Coinciden, cambia la contraseña")
                params['password'] = userData.password;
            } else {
                console.log("Quieres cambiar password, pero no coinciden.")
            }
        } else {
            console.log("Actualiza solamente los datos de usuario. Nada de contraseñas.")
        }

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/wp/v2/users/" + userId, params)
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    createSingleUser({dispatch, commit, state}, userData) {

        console.log(userData);

        const params = {
            first_name: userData.first_name,
            last_name: userData.last_name,
            email: userData.email,
            password: userData.password,
            rut: userData.rut,
            username: userData.username,
            active: '1'
        };

        if (undefined !== userData.password) {
            if (userData.password_confirm === userData.password) {
                console.log("Coinciden, acepta la contraseña");
                params['password'] = userData.password;
            } else {
                console.log("Quieres crear usuario, pero no coinciden los password.")
            }
        } else {
            console.log("Se va sin contraseñas, la generará automáticamente y no es la idea.")
        }

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().post("/wp/v2/users?XDEBUG_SESSION_START=PHP_STORM", params)
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        });

    },

    deleteSingleUser({dispatch, commit, state}) {

        const userData = state.data[0];
        const userId = userData.id;
        const params = {
            force: "true",
            reassign: 1
        };

        const token = this.state.login.user.token;

        Vue.prototype.$Api().defaults.headers.common["Authorization"] = `Bearer ${token}`;

        return new Promise((resolve, reject) => {

            Vue.prototype.$Api().delete("/wp/v2/users/" + userId, {params})
                .then((response) => {
                    resolve();
                })
                .catch((response) => {
                    const code = response.response.data.code;
                    const httpCode = response.response.data.data.status;
                    console.log(httpCode, code);
                    reject();
                });

        })

    }

};

export const users = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};